import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { usePage } from '../../context/PageContext';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { TransactionSections } from '../../constants/transaction';
import Transactions from './transactions';
import Timesheet from './timesheet';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { ROUTES } from '../../constants/constants';
import { useAnalytics } from '../../hooks/useAnalytics';
import { AnalyticsPage } from '../../interface/analytics';
import CustomTabs from '../customTabs/customTabs';

const TransactionTabView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { trackPage } = useAnalytics();
  const { clear, push, updateTop } = useNavigationStack();
  const fromTab = location?.state?.fromTab ?? TransactionSections.transaction;

  const [selectedTab, setSelectedTab] = useState<string>(String(fromTab));
  const { setTitle } = usePage();

  useEffect(() => {
    updateTop({ fromTab: selectedTab });
  }, [selectedTab]);

  useEffect(() => {
    trackPage(AnalyticsPage.TRANSACTION_LISTING);
  }, [trackPage]);

  const items = useMemo(
    () => [
      {
        key: String(TransactionSections.transaction),
        label: t('common:tab.transactions'),
        children: (
          <div className="h-full">
            <Transactions />
          </div>
        ),
      },
      {
        key: String(TransactionSections.timesheet),
        label: t('common:tab.timesheet'),
        children: (
          <div className="h-full">
            <Timesheet />
          </div>
        ),
      },
    ],
    [],
  );

  const handleHome = () => {
    clear();
    push(ROUTES.DASHBOARD);
  };

  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        title={t('transaction:transactions')}
        showMenu
        showSettings
        handleHome={handleHome}
      />,
    );
  }, []);

  return (
    <div className="dashboard-wrapper">
      <CustomTabs activeKey={selectedTab} onChange={setSelectedTab} items={items} />
    </div>
  );
};

export default TransactionTabView;
